import {gql, useMutation} from "@apollo/client";
import {DspType} from "../../../../../graphql/types/DspType";
import {DSP_FIELDS} from "../../../../../graphql/types/DspType";

export interface DspWithWarehousesInput {
    id?: string;
    name: string;
    fullName: string;
    dspCode?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    operationEmail?: string;
    status: number;
    /** 不传表示本次不修改账期（新建时后端落默认值 12） */
    paymentTermDays?: number;
    /** 不传表示本次不修改（新建时后端落默认值 10） */
    exitDelayDays?: number;
    warehouseIds: number[];
    openSettlementConfig: boolean;
    settlementTrackingPoint?: string;
    billingCycleConfiguration?: number;
    settlementMode?: number;
    billType?: number[];
    timeZoneIana?: string;
    billUnitType?: number;
}

export const SAVE_DSP_WITH_WAREHOUSES = gql`
  mutation SaveDspWithWarehouses($input: DspWithWarehousesTypeInput!) {
    saveDspWithWarehouses(input: $input) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

export interface SaveDspWithWarehousesResponse {
    saveDspWithWarehouses: DspType;
}

export interface SaveDspWithWarehousesVariables {
    input: DspWithWarehousesInput;
}

export const useSaveDspWithWarehouses = () => {
    return useMutation<SaveDspWithWarehousesResponse, SaveDspWithWarehousesVariables>(SAVE_DSP_WITH_WAREHOUSES);
}; 